/* README:
 * Removed  "import * as $ from 'jquery'" since the invocation of tooltip was breaking on it.
 * We rely on a global imported jQuery, which has the tooltip method,
 * to get our tests to consistently work for now.
 * TODO: [ ] Componentize jQuery and tooltips together.
 * */

import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface TooltipProps {
  title: string;
  placement?: "top" | "right" | "bottom" | "left";
  animationDuration?: number;
  delay?: number;
  maxWidth?: number;
  theme?: string;
  disableOnTouchScreen?: boolean;
  className?: string;
}

export default class Tooltip extends React.PureComponent<TooltipProps> {
  static defaultProps = {
    animationDuration: 100,
    placement: 'top',
    delay: 100,
    maxWidth: 250,
    theme: 'tooltipster-borderless',
    disableOnTouchScreen: false,
  };

  componentDidMount() {
    this.mountTooltip();
  }

  componentDidUpdate() {
    const domNode  = ReactDOM.findDOMNode(this);
    $(domNode).tooltipster('content', this.props.title)
  }

  componentWillUnmount() {
    this.destroyTooltip();
  }

  mountTooltip() {
    if ('ontouchstart' in document.documentElement && this.props.disableOnTouchScreen) {
      return;
    }

    const domNode = ReactDOM.findDOMNode(this);
    $(domNode).tooltipster({
      animationDuration: this.props.animationDuration,
      side: this.props.placement,
      content: this.props.title,
      delay: this.props.delay,
      maxWidth: this.props.maxWidth,
      theme: this.props.theme,
    });
  }

  destroyTooltip() {
    const domNode = ReactDOM.findDOMNode(this);
    $(domNode).tooltipster('destroy');
  }

  render() {
    return (
      <span className={this.props.className}>
        {this.props.children}
      </span>
    );
  }
}




// WEBPACK FOOTER //
// ./app/javascript/components/tooltip.tsx